module.exports = __webpack_public_path__ + "static/media/Akkurat-Mono.b4a1c75b.woff";